import React from 'react';
import { useLocation } from 'react-router-dom';
import FieldGroupSchemaManager from '../admin/FieldGroupSchemaManager';
import { deviceSchemaClient } from '../../api/schema';

/** 设备模板 (2026-09-12 从「Schema 管理」拆出, 归设备工况): 设备动态字段组. ?focus=<archCode> 定位到该框架的组. */
function DeviceTemplateAdmin() {
    const focus = new URLSearchParams(useLocation().search).get('focus') || '';
    return (
        <FieldGroupSchemaManager
            client={deviceSchemaClient}
            resource="device_schema"
            domainLabel="设备"
            valueHint="按设备 (deviceKey) 存值, 设备工况页录入; 作用域: 通用 → 工艺框架 → 加工类型"
            matrixLayout
            archScope
            focusTemplate={focus}
        />
    );
}

export default DeviceTemplateAdmin;
